import Icons, { IconsProps } from '../../Icons';

export type CheckboxOutlineBlankFilledProps = IconsProps;

export function CheckboxOutlineBlankFilled(props: CheckboxOutlineBlankFilledProps) {
  return (
    <Icons {...props}>
      <path d="M4.463 19.538C4.771 19.846 5.15833 20 5.625 20H18.375C18.8417 20 19.2293 19.846 19.538 19.538C19.846 19.2293 20 18.8417 20 18.375V5.625C20 5.15833 19.846 4.771 19.538 4.463C19.2293 4.15433 18.8417 4 18.375 4H5.625C5.15833 4 4.771 4.15433 4.463 4.463C4.15433 4.771 4 5.15833 4 5.625V18.375C4 18.8417 4.15433 19.2293 4.463 19.538Z" />
    </Icons>
  );
}

// https://www.zhangxinxu.com/sp/svgo/
// https://jakearchibald.github.io/svgomg/
